import React from 'react';
import styled from 'styled-components';

export default styled.div`
  background: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  bottom: 4px;
  color: white;
  font-size: 12px;
  font-weight: bold;
  opacity: 0;
  padding: 10px;
  pointer-events: none;
  position: absolute;
  right: 4px;
  z-index: 999999;
  transition: opacity 0.21s ease-in-out;
  user-select: none;
`;
